import theme from '@styles/theme';

export const MessageCross = ({
  color = theme.palette.primary[0],
  width = 24,
  height = 24,
  className,
  ...otherProps
}: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={`icon-message-cross ${className}`}
      {...otherProps}
    >
      <g id='IconMessageCross'>
        <path
          id='Vector'
          d='M10.131 19.294C10.735 19.41 11.359 19.473 12 19.473C16.952 19.473 21 15.83 21 11.291C21 6.752 16.952 3.11 12 3.11C7.048 3.11 3 6.752 3 11.291C3 13.974 4.42 16.336 6.599 17.826C6.598 18.68 6.6 19.832 6.6 21.041L10.13 19.29M9.5 8.9L14.5 13.9M14.5 8.9L9.5 13.9'
          stroke={color}
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
    </svg>
  );
};
